export default function PageHeader({ overline, title, description, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
      <div className="max-w-2xl">
        {overline && (
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#8A9188] mb-3">
            {overline}
          </p>
        )}
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1A1D1A] font-light leading-[1.1]">
          {title}
        </h1>
        {description && (
          <p className="mt-3 text-[#5C635A] leading-relaxed max-w-xl">{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}
